import thunk from "redux-thunk";
import createDebounce from "redux-debounced";
import rootReducer from "./rootReducer";
import { createStore, applyMiddleware, compose } from "redux";

// Importações do redux-persist
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

// Configuração do persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "company"], // Apenas persiste auth e company
};

const middleware = [thunk, createDebounce()];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Criar o persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Criar a store com o persisted reducer
const store = createStore(
  persistedReducer,
  {},
  composeEnhancers(applyMiddleware(...middleware))
);

// Criar o persistor
export const persistor = persistStore(store);
export default store;
